import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './preloader.css';

const Preloader = ({ onComplete }) => {
  const ref = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.timeline({ onComplete })
        .from('.preloader_letter', {
          opacity: 0,
          y: 64,
          duration: 0.55,
          stagger: 0.07,
          ease: 'power3.out'
        })
        .from('.preloader_dot', {
          opacity: 0,
          scale: 0,
          duration: 0.35,
          ease: 'back.out(2)'
        }, '-=0.1')
        .from('.preloader_tagline', {
          opacity: 0,
          y: 14,
          duration: 0.4,
          ease: 'power2.out'
        }, '-=0.1')
        .to(ref.current, {
          yPercent: -100,
          duration: 0.75,
          delay: 0.45,
          ease: 'power3.inOut'
        });
    }, ref);

    return () => ctx.revert();
  }, [onComplete]);

  return (
    <div ref={ref} className='preloader'>
      <div className='preloader_inner'>
        <div className='preloader_logo'>
          {'EVENTRA'.split('').map((l, i) => (
            <span key={i} className='preloader_letter'>{l}</span>
          ))}
          <span className='preloader_dot'>.</span>
        </div>
        <div className='preloader_tagline'>Event Ticketing Platform</div>
        <div className='preloader_bar'><div className='preloader_progress' /></div>
      </div>
    </div>
  );
};

export default Preloader;
